import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { reload } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { localStateSelector, makeSectionIdsSelector } from "./selectors";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    const sectionsSelector = makeSectionIdsSelector();
    const sectionIds = sectionsSelector(state, { source: props.source });
    return {
      ...props,
      completed: localState.completed,

      total: localState.total,
      sectionIds: sectionIds
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  reload: () => dispatch(reload(props))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
